import { type DispatcherEvent } from '@carvana/merch-native';
import { Events } from '@carvana/vdp-events';
import AccountModalTab from '~/constants/accountModalTab';
import AccountModalSettings from '~/contracts/common/AccountModalSettings';
import { getSourcedSendMessageToNative } from '~/native/common/dispatchers';

declare global {
  interface Window {
    carvana?: {
      onLoginSuccess?: () => void;
    };
  }
}

const getEventsElement = () => document.getElementById('header-plugin-events');

const filterUndefined = (obj: Record<string, any>) =>
  Object.entries(obj).reduce(
    (acc, [key, value]) => {
      if (value !== undefined) acc[key] = value;

      return acc;
    },
    {} as Record<string, any>
  );

type AccountModalParams = AccountModalSettings & {
  callerIdentifier: string;
  nativeOptions?: {
    eventPayload?: Record<string, any>;
    eventDispatch: DispatcherEvent;
    eventSource: string;
  };
  onError?: () => void;
  onSuccess?: () => void;
  tab?: AccountModalTab;
};

// TODO: Update to use core-events
export function openAccountModal({
  callerIdentifier,
  nativeOptions,
  modalHeading,
  modalTitle,
  onError,
  onSuccess,
  submitButtonText,
  tab
}: AccountModalParams) {
  getEventsElement()?.dispatchEvent(
    new CustomEvent(Events.HeaderAccountModalOpen, {
      bubbles: true,
      detail: filterUndefined({
        callerIdentifier,
        modalHeading,
        modalTitle,
        onError,
        onSuccess,
        submitButtonText,
        tab
      })
    })
  );

  if (nativeOptions) {
    const { eventPayload = {}, eventSource, eventDispatch } = nativeOptions;

    getSourcedSendMessageToNative(eventSource)(eventDispatch, eventPayload, {
      callback: () => {
        // Store the onSuccess handler in a global variable, so it can be called from the native app.
        window.carvana = window.carvana ?? {};
        window.carvana.onLoginSuccess = onSuccess;
      }
    });
  }
}

// TODO: Update to use core-events
export function closeAccountModal() {
  getEventsElement()?.dispatchEvent(new Event(Events.HeaderAccountModalClose));
}
